/**
 * The Default SuperAdmin Menu
 */
export const AdminModulesList = [{
      label: 'Mandantenliste',
      icon: 'business',
      path: 'client-list'
  }];